
<template>
  <v-container fluid grid-list-xl page>
    <v-layout row wrap>
      <v-flex xs12 sm8 md12>
        <section-header v-text="page.headline"></section-header>
        <div class="subheading justify" v-html="page.description"></div>
        <div class="my-5"></div>
      </v-flex>
    </v-layout>
    <!-- Your contet -->

    <div class="display-3 grey--text text--darken-1">Send a Notification</div>
    <div
      class="title grey--text text--darken-1"
    >from any device, without having to download any applications</div>

    <v-layout>
      <v-flex>
        <v-card class="justify-center">
          <v-container fluid grid-list-md>
            <v-layout row wrap class="justify-center">
              <v-flex xs12 md6 lg3 offset-2>
                <v-card flat tile>
                  <v-img justify-center src="/static/send.png" width="100" aspect-ratio="1"></v-img>

                  <v-card-title primary-title>
                    <div>
                      <h3 class="headline mb-0">NOTIFY</h3>
                      <div>Unlike uncertified e-mail or SMS, certified notifications make it possible to carry out guaranteed electronic communications by revealing the traceability of the delivery and its reading, at the same time as certifying all the content using encryption technology.
                          </div>

                    </div>
                  </v-card-title>

                  <v-card-actions>
                  
                  </v-card-actions>
                </v-card>
              </v-flex>

              <!-- --------- -->

              <v-flex xs12 md6 lg3>
                <v-card flat tile>
                  <v-img src="/static/digital-signature.png" width="100" aspect-ratio="1"></v-img>

                  <v-card-title primary-title xs12 sm3>
                    <div>
                      <h3 class="headline mb-0">TAKE CONTROL</h3>
                      <div>With Securyty certified notifications you will be able to send relevant information electronically via SMS or e-mail, with acknowledgement of receipt and with much lower costs than traditional alternatives.
</div>
                    </div>
                  </v-card-title>

                  <v-card-actions>

                  </v-card-actions>
                </v-card>
              </v-flex>

              <v-flex xs12 md6 lg3>
                <v-card flat tile>
                  <v-img s src="/static/admin.png" width="100" aspect-ratio="1"></v-img>

                  <v-card-title primary-title xs12 sm3>
                    <div>
                      <h3 class="headline mb-0">MANAGE</h3>
                      <div>Monitor the status of your signature requests from the control panel, keep the documents organized and access them quickly.</div>
                    </div>
                  </v-card-title>

                  <v-card-actions>

                  </v-card-actions>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
    <v-spacer></v-spacer>
    <div>
      <v-layout wrap align-content-space-around text-xs-center color="grey" >
        <v-flex xs1></v-flex>
        <v-flex xs4>
          <v-card flat color="transparent">
            <v-card-text class="px-0">
            <img src="/static/contract.png" />
            </v-card-text>
          </v-card></v-flex>
        <v-flex xs3><v-card flat color="transparent"><v-card-text class="px-0">
        <v-layout  column>
        <span class="display-5">
          <br/><br/>
        </span>
        <span class="display-2">
          Try it by yourself
        </span>
        <v-btn color="primary" dark large @click="createSignature" v-ga="$ga.commands.trackCertifiedNotificationTryButton.bind(this)">Try it</v-btn>
      </v-layout>
        </v-card-text></v-card></v-flex>
        <v-flex xs3><v-card flat color="transparent"><v-card-text class="px-0">
                      <span class="title">You can send a document and keep track if it is reaceived and read in a legal way </span>

        </v-card-text></v-card></v-flex>
      <v-flex xs1></v-flex>
    </v-layout>
        </div>

<v-layout height="100" >
  <v-card height="100" flat color="grey">
  </v-card>
</v-layout>


 <div class="display-2 black--text text--darken-3 justify-center"></div>
    <div
      class="title black--text text--darken-1"
    ></div>

        
    <v-dialog v-model="isCreateSign" persistent max-width="500px">
      <v-card>
        <v-toolbar color="orange" dark>
          <!-- <v-toolbar-side-icon></v-toolbar-side-icon> -->
          <v-toolbar-title>Create Certified Notification Operation</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip right>
            <v-icon
                slot="activator"
                color="white"
                dark
              >help_outline</v-icon>
            <span><b>Certified Notification : <br><br>- Send document and keep track of it<br><br>
                  </b>
            </span>
          </v-tooltip>
        </v-toolbar>
        <create-sign-page :scrollTop=scrollTop signatureType="notification"></create-sign-page>
        <v-card-actions>
          <v-spacer></v-spacer>
           <v-btn color="primary" @click.native="closeSignaturePage">Close</v-btn>
          </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="isLoginNeeded"  max-width="300px">
      <v-card>
        <v-toolbar color="orange" dark>
          <v-toolbar-title>Login required</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap></v-layout>
                  <span>Please log in or register to use the service
                </span>
              </v-container>
            </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
           <v-btn color="primary" @click.native="isLoginNeeded = false">Close</v-btn>
          </v-card-actions>
        </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import CreateSignPage from "./CreateSignPage";

export default {
  components: {
    CreateSignPage
  },
  // mounted() {
  //   // Google Analytics
  //   this.$ga.page(this.$router);
  // },
  data() {
    return {
      isLoginNeeded: false,
      isCreateSign: false,
      page: {
        title: "Notified Certification",
        headline: "Notified Certification",
        description: `Send a certified notification by email`
      },
      breadcrumbs: [
        {
          text: "Src",
          disabled: false
        },
        {
          text: "Views",
          disabled: false
        },
        {
          text: "Blank",
          disabled: false
        }
      ],
      scrollTop: 0
    };
  },
  methods: {
    createSignature() {
      //this.$router.push("CreateSignPage")
      var current = this.$store.getters.userData;
      if (current == null || current.userEmail == null) {
        this.isLoginNeeded = true;
        this.$ga.event({
          eventCategory: "Loggin needed certified notification", // str
          eventAction: "click", // str
          eventLabel: "TryButton", // str
          eventValue: 0 // int
        });
        return;
      }
      this.scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      document.getElementsByTagName("body")[0].className = "noscroll";
      this.isCreateSign = true;
    },
    closeSignaturePage() {
      document.body.removeAttribute("class", "noscroll");
      window.scrollTo(0, this.scrollTop);
      this.isCreateSign = false;
    }
  }
};
</script>
